import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  // Link,
  SocialButtons,
  GetStartedInput,
  AboutBanner
} from '../../components'
// import {Row, Col} from 'react-flexbox-grid'
import Styles from './Toolkit.css'
import container from '../../helpers/container'
// import ReactPlayer from 'react-player'
import {CopyToClipboard} from 'react-copy-to-clipboard';

@CSSModules(Styles, {allowMultiple:true})
export default class Toolkit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about gun free and socially responsible investment options in the plan.\nI am concerned about the financial and moral risks associated with investing my retirement savings in civilian firearm companies. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from manufacturers of civilian firearms. In the wake of media attention driven by mass shootings, major retailers are moving to restrict or cease gun sales, and lawmakers are discussing increased regulation of the gun industry. These facts point to a substantial financial risk of investing in gun companies.\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what gun companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any gun free, socially responsible options?\nSocially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that "environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment" and can be used when making decisions related to fiduciary duty.\nThere is an online tool, gunfreefunds.org, which screens many commonly available mutual funds for investments in gun companies, and identifies funds that are socially responsible and gun free. If none of our current plan options are socially responsible and gun free, this tool could be used to find suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]',
      copied: false,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  onCopy = () => {
    this.setState({copied: true});
  };

  renderToolkitContent = (toolkitTitle, url) => {
    const message = 'Action toolkit to move your money'

    return (
      <div styleName='toolkit'>
        <div styleName='toolkit-inner'>
          <div styleName='answer-title'>
            Step 1 – Talk to your colleagues and build a coalition
          </div>
          <div styleName='content-info'>
            <p>To effectively advocate for new offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you&rsquo;re writing to someone in power, advocating on behalf of 20 or even 10 people carries a lot more weight than just one. One way to spur interest would be sharing the results from your Gun Free Funds search among fellow employees. All plan participants are offered the same group of mutual funds as you are, so they are probably asking the same questions right now.</p>
            <p>Some companies have “corporate responsibility teams”. If there isn’t one already, it may be time to create one for weapon free investing. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media.</p>
          </div>
          <div styleName='answer-title-spaceabove'>
            Step 2 – Identify the best people to speak with
          </div>
          <div styleName='content-info'>
            <p>The 401(k)/403(b) plan administrator, manager, or coordinator should be known if you are a plan participant, and that&rsquo;s where to start. There could also be a chief corporate responsibility officer or employee engagement manager, and those could be good resources. An effective method is to go to the LinkedIn pages of those people and find who might have some sympathy for the cause. Do any of them volunteer or have connections with gun violence organizations? Look for indicators that they&rsquo;re friendly to corporate responsibility and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it&rsquo;s an important issue for many employees. If it&rsquo;s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.</p>
          </div>
          <div styleName='answer-title-spaceabove'>
            Step 3 – Bring a solution to the table
          </div>
          <div styleName='content-info'>
            <p>The usual starting point in these conversations is: &ldquo;We want to reduce the future risk of our 401(k) fund choices. We also want to invest in a peaceful future. How can we enhance our 401(k) choices to do so?&rdquo; Getting new fund choices added to the list of the existing plan options is a formal process, and could take up to a year to be added. Larger companies often have some form of investment committee, which engages an investment advisor. There may be some funds in your plan that you see contain only one gun company. You could ask the plan administrator to call the fund manager and say, &ldquo;Is there a substitute for this one company? If you made one change you would be gun free!&rdquo;</p>
            <p>If the investment advisor and plan administrator refuse to help in swapping out some gun-heavy funds for some gun free funds, you may need to get fellow employees to sign a petition requesting the change and send it to the investment committee. If you are told, &ldquo;But you&rsquo;ll make less money if you&rsquo;re not invested in guns,&rdquo; you can say, &ldquo;Actually, guns are a risky investment. We want to diversify, and be part of building a less violent future.&rdquo;</p>
          </div>

          <div styleName='answer-title-spaceabove'>
            Sample letter to plan administrator
          </div>
          <div styleName='content-info'>
            <div styleName='letter-boxquote'>
              <p>Dear Plan Administrator,</p>

              <p>I am an employee of <strong>[Company Name]</strong>, and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about gun free and socially responsible investment options in the plan.</p>

              <p>I am concerned about the financial and moral risks associated with investing my retirement savings in civilian firearm companies. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from civilian firearms. In the wake of media attention driven by mass shootings, major retailers are moving to restrict or cease gun sales, and lawmakers are discussing increased regulation of the gun industry. These facts point to a substantial financial risk of investing in gun companies.</p>

              <p><strong>I believe it is my right to know what companies my retirement savings are invested in.</strong> Can you please tell me how I can find out what gun companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any gun free, socially responsible options?</p>

              <p>Socially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.</p>

              <p>There is an online tool, <strong>gunfreefunds.org</strong>, which screens many commonly available mutual funds for investments in gun companies, and identifies funds that are socially responsible and gun free. <strong>If none of our current plan options are socially responsible and gun free, this tool could be used to find suitable mutual funds that could be included in our plan.</strong></p>

              <p>Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.</p>
              <p>Best,</p>
              <p><strong>[Your Name]</strong></p>
              <p><strong>[Your contact information (company department, email, phone)]</strong></p>
            </div>

            <CopyToClipboard
              onCopy={this.onCopy}
              text={this.state.value}>
              <button
                styleName='letter-boxquote-copy-button'>

                {
                  this.state.copied ?
                    'Copied!' :
                    'Copy to clipboard'
                }

                {
                  this.state.copied ?
                  null :
                  (
                    <span>&nbsp;<i className='fa fa-files-o'/></span>
                  )
                }

              </button>
            </CopyToClipboard>

          </div>

          <SocialButtons message={message} link={url}/>

        </div>
      </div>
    )
  }

  render() {
    const title = 'Gun free action toolkit'
    const description = 'Get your money out of gun stocks. Use the Gun Free Funds Action Toolkit to make a change and move your money.'
    const url = config.domain + config.routes.toolkit

    const bannerImage = 'green'
    const bannerHeadline = 'Gun free action toolkit'
    const bannerSubtitle = 'Action toolkit to move your money'

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>{bannerHeadline}</div>
                <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
              </div>
            </div>
          </div>
        </div>

        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>
            <div styleName='title'>
              If you’re an individual investor
            </div>
            <div styleName='content-info'>
              <p>
                It’s your money, and your financial advisor works for you. You just need to discuss what you have learned about your holdings and how you would like them changed to align with your values. An investment professional will advise you of potential risk and you can make your own decisions.
              </p>
              <p>
                You can trade your own portfolio, or tell your manager to do it. They may push back and tell you that you’ll make less money. You can reply, “Maybe, maybe not, but it’s my money, I want less risk, and gun companies are a risky business.” It’s a financial advisor's job to manage your money, so you should drive home this point in no uncertain terms.
              </p>
              <p>
                Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to remove the risk, not a specific fund; focus on risk, especially future risk, as well as returns. If they’re unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.
              </p>
            </div>
            <div styleName='title'>
              Adding gun free options to your retirement plan
            </div>
            <div styleName='content-info'>
              <p>
                If your employer-offered 401(k) already has options that meet your gun-free investing needs, that's great! But many plans only offer diversified funds that own the whole market, including gun companies. It is possible to change what the plan offers, but it will take more effort than if you have an IRA or a personal portfolio  that you solely control and has unlimited options. You will need to engage the plan administrator to help find the right blend of options to satisfy the many employees that all invest in the same group of mutual funds. This may take time and possibly some coordination with your co-plan participants.
              </p>
            </div>
          </div>
        </div>

        { this.renderToolkitContent(title, url) }

        <GetStartedInput />

        <div styleName='ab-container'>
          <div styleName='ab-container-inner'>
            <AboutBanner />
          </div>
        </div>

      </div>
    )
  }
}
